import { useEffect, useRef, useState } from "react";
import useWindowDimensions from "./useWindowDimensions";
export const useCarrouselSlide = ({ activeIndex, setActiveIndex, dataLength, scrollLeft, scrollPositionDiff }) => {
  const [isClicked, setIsclicked] = useState(false)
  const scrollRef = useRef(null);
  const { width } = useWindowDimensions()
  function scrollOnMobile(index) { scrollRef.current.scrollTo({ left: scrollLeft * index, behavior: "smooth" }); }
  useEffect(() => { scrollOnMobile(activeIndex); },
    // eslint-disable-next-line
    [activeIndex]);

  const handleScroll = () => {
    if (width > 500) return;
    if (isClicked) return;
    const scrollPosition = scrollRef?.current?.scrollLeft +  scrollPositionDiff;
    const itemWidth = scrollRef.current?.offsetWidth ;
    const index = Math.floor(scrollPosition / itemWidth);
    console.log("INDEX: ",index)
    const newIndex = index >= dataLength ? index - 1 : index
    console.log("NEW INDEX: ",index)
    setActiveIndex(newIndex);
  };

  const handleClick = (id) => {
    setIsclicked(true);
    setActiveIndex(id);
    setTimeout(() => {
      setIsclicked(false)
    }, 500);
  }

  function handlePrev() {
    setIsclicked(true);
    setActiveIndex((prevIndex) => {
      const newIndex = prevIndex - 1;
      return newIndex < 0 ? dataLength - 1 : newIndex;
    });
    setTimeout(() => {
      setIsclicked(false)
    }, 500);
  }

  // Function to handle moving to the next card
  function handleNext() {
    setIsclicked(true);
    setActiveIndex((prevIndex) => {
      const newIndex = prevIndex + 1;
      return newIndex >= dataLength ? 0 : newIndex;
    });
    setTimeout(() => {
      setIsclicked(false)
    }, 500);
  }
  const generatePadingX = (boxWidth, cardWidth) => {
    let paddingX = "10%";
    if (width > 500) { return; }
    if (boxWidth) { paddingX = ((boxWidth - cardWidth) / 2); }
    return paddingX
  }
  return { scrollRef, handleScroll, handleClick, generatePadingX, handleNext, handlePrev }
}